import React from 'react';
import coppelpay_logo from '../../../assets/coppelpay25.png';
import atrato_logo from '../../../assets/atrato.png';
import paypal_logo from '../../../assets/paypal_logo.png';
import mp_logo from '../../../assets/MP_RGB_HANDSHAKE_color_horizontal.png';

const Totals = ({
  total,
  handleModal,
  cuponApply,
  promotion,
  removePromoCode,
  erros,
}) => (
  <div className="cart_totals">
    <div className="totals-card">
      <div className="totals-header">
        <h5 className="xs_hidden">Resumen del Pedido</h5>
        <div className="total-amount">
          <span className="total-label">Total:</span>
          <span className="total-value">${total.total_str}</span>
        </div>
      </div>

      {promotion && <RenderPromo promotion={promotion} total={total} />}

      <div className="totals-actions">
        <Cupons
          cuponApply={cuponApply}
          cuponcode={promotion ? promotion.code : ''}
          removePromoCode={removePromoCode}
          erros={erros}
          className="xs_hidden"
        />

        <div className="checkout-section">
          <a
            className="btn btn-lg btn-block checkout-btn"
            href="/checkout"
            id="checkout-btn"
          >
            <i className="fas fa-lock mr-2"></i>
            Continuar a Pago Seguro
          </a>

          <div className="payment-methods">
            <div className="payment-icons">
              <img src={mp_logo} alt="Paga con Mercado Pago" />
              <img src={atrato_logo} alt="Paga con Atrato" />
              {/* Coppel pay no longer used */}
              {/* <img
                src={coppelpay_logo}
                style={{ width: '100px', height: 'auto' }}
                alt="Paga con CoppelPay"
              /> */}
              <img src={paypal_logo} alt="Paga con PayPal" />
            </div>
          </div>
        </div>

        <div className="save-order-section xs_hidden">
          <button
            className="btn btn-outline-secondary btn-block save-order-btn"
            onClick={handleModal}
          >
            <i className="far fa-save mr-2"></i>
            Guardar mi Pedido
          </button>
        </div>
      </div>
    </div>
  </div>
);

export const Cupons = ({
  cuponApply,
  cuponcode,
  removePromoCode,
  erros,
  className,
}) => (
  <div className={`cupon_section ${className ? className : ''}`}>
    {cuponcode ? (
      <div className="promotion-applied">
        <div className="promotion-info">
          <i className="fas fa-tag promotion-icon"></i>
          <span className="promotion-code">{cuponcode}</span>
          <span className="promotion-label">Código aplicado</span>
        </div>
        <button
          className="btn btn-sm btn-outline-danger remove-promotion-btn"
          onClick={removePromoCode}
          title="Remover código"
        >
          <i className="fas fa-times"></i>
        </button>
      </div>
    ) : (
      <div className="cupon-input-section">
        {erros && (
          <div className="alert alert-danger alert-sm" id="alert-shake">
            <i className="fas fa-exclamation-circle mr-2"></i>
            {erros}
          </div>
        )}
        <div className="input-group">
          <input
            type="text"
            className="form-control cupon-input"
            placeholder="Código Promocional"
            aria-label="Código Promocional"
            id="cupon_code"
          />
          <div className="input-group-append">
            <button
              className="btn btn-outline-primary apply-cupon-btn"
              onClick={cuponApply}
            >
              Aplicar
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
);

function renderPromotion(promotion) {
  switch (promotion.type) {
    case 'percentage_all':
      return `${promotion.value * 100}% de descuento`;
    case 'percentage':
      return `${promotion.value * 100}% de descuento en productos selecionados`;
    case 'amount':
      const discountValue = parseFloat(promotion.value).toFixed(2);
      return `$${discountValue} de descuento en productos selecionados`;
    default:
      return null;
  }
}

const RenderPromo = ({ promotion, total }) => (
  <div className="promotion-summary">
    <div className="discount-amount">
      <span className="discount-label">Descuento:</span>
      <span className="discount-value">- ${total.discount}</span>
    </div>
    <div className="promotion-description">{renderPromotion(promotion)}</div>
  </div>
);

export default Totals;
